export const existingJobDescs = [
  {
    title: "Frontend Developer",
    text: "As a Frontend Developer, you will be responsible for designing and implementing user interfaces for web applications. You will work closely with backend developers to integrate APIs and ensure a seamless user experience. Proficiency in HTML, CSS, JavaScript, and frameworks like React or Angular is required.",
    skills: ["HTML", "CSS", "JavaScript", "React", "Angular", "Responsive Design", "UI/UX"]
  },
  {
    title: "Backend Engineer",
    text: "As a Backend Engineer, your primary responsibility will be to develop and maintain server-side logic, databases, and APIs. You will collaborate with frontend developers to ensure data consistency and optimize application performance. Experience with server-side languages such as Node.js, Python, or Java is essential.",
    skills: ["Node.js", "Python", "Java", "SQL", "REST APIs", "Database Design", "Microservices"]
  },
  {
    title: "Product Manager",
    text: "The Product Manager will oversee the development and lifecycle of products from conception to launch. Responsibilities include defining product vision, gathering and prioritizing requirements, and working with cross-functional teams to deliver high-quality products. Strong communication and leadership skills are necessary.",
    skills: ["Product Roadmap", "Agile Methodologies", "User Research", "Stakeholder Management", "JIRA", "Communication"]
  },
  {
    title: "Marketing Manager",
    text: "As a Marketing Manager, you will develop and execute marketing strategies to promote products and services. This includes market research, campaign planning, and performance analysis. Experience with digital marketing tools and platforms is preferred.",
    skills: ["SEO", "Content Marketing", "Google Analytics", "Social Media Marketing", "Email Campaigns", "Brand Strategy"]
  },
  {
    title: "Sales Executive",
    text: "The Sales Executive will identify and pursue new business opportunities, build relationships with potential clients, and close sales to meet revenue targets. Strong negotiation and communication skills are crucial for success in this role.",
    skills: ["Lead Generation", "Negotiation", "CRM Tools", "Sales Pitching", "Customer Relationship Management", "Account Management"]
  },
  {
    title: "Human Resources Manager",
    text: "The Human Resources Manager will oversee recruitment, employee relations, performance management, and compliance with labor laws. Experience in HR management and a strong understanding of employment legislation are required.",
    skills: ["Recruitment", "Employee Relations", "Performance Management", "HR Policies", "Compliance", "Onboarding"]
  },
  {
    title: "Finance Analyst",
    text: "As a Finance Analyst, you will analyze financial data, prepare reports, and assist in budgeting and forecasting processes. Proficiency in financial modeling and knowledge of financial regulations are essential.",
    skills: ["Financial Analysis", "Excel", "Financial Modeling", "Budgeting", "Forecasting", "Accounting Principles"]
  },
  {
    title: "Operations Manager",
    text: "The Operations Manager will oversee daily operations, manage resources, and implement processes to improve efficiency. Strong problem-solving skills and experience in operations management are necessary.",
    skills: ["Process Improvement", "Project Management", "Resource Management", "Lean/Six Sigma", "Problem Solving", "Logistics"]
  },
  {
    title: "Customer Support Specialist",
    text: "The Customer Support Specialist will assist customers by providing information, resolving issues, and ensuring a positive customer experience. Excellent communication skills and a customer-focused attitude are required.",
    skills: ["Customer Service", "CRM Tools", "Communication", "Problem Solving", "Ticketing Systems", "Empathy"]
  },
  {
    title: "Data Analyst",
    text: "As a Data Analyst, you will collect, process, and analyze data to provide insights that inform business decisions. Proficiency in data analysis tools and statistical methods is essential.",
    skills: ["SQL", "Python", "R", "Excel", "Data Visualization", "Tableau", "Power BI", "Statistics"]
  }
];
